import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IOrderFeature } from './order.feature.state';
import { OrderState } from './order.state';

export const getOrderState: MemoizedSelector<IOrderFeature, OrderState> = createFeatureSelector<OrderState>(
  nameof<IOrderFeature>('OrderFeature')
);

export const getIsLoading = createSelector(getOrderState, (state: OrderState) => state.isLoading);

export const getIsApplyingDiscount = createSelector(getOrderState, (state: OrderState) => state.isApplyingDiscount);

export const getFailures = createSelector(getOrderState, (state: OrderState) => state.failures);

export const getOrderVerified = createSelector(getOrderState, (state: OrderState) => state.orderverified);

export const getDiscount = createSelector(getOrderState, (state: OrderState) => state.discountResponse);

export const getOrderDetails = createSelector(getOrderState, (state: OrderState) => state.orderDetails);

export const getPaymentSessionCreate = createSelector(getOrderState, (state: OrderState) => state.paymentSessionCreate);

export const getPaymentSessionRetrieve = createSelector(getOrderState, (state: OrderState) => state.paymentSessionRetrieve);

export const getSubTotal = createSelector(getOrderState, (state: OrderState) => state.subTotal);

export const getTimeSlot = createSelector(getOrderState, (state: OrderState) => state.timeSlot);

export const getOrderLocation = createSelector(getOrderState, (state: OrderState) => state.orderLocation);

export const getDeliveryLocation = createSelector(getOrderState, (state: OrderState) => state.deliveryLocation);

export const getChildDeliveryLocation = createSelector(getOrderState, (state: OrderState) => state.childDeliveryLocation);

export const getTable = createSelector(getOrderState, (state: OrderState) => state.table);

export const getOrderCompletedOn = createSelector(getOrderState, (state: OrderState) => state.orderCompletedOn);

export const getGuestCheckoutOrderID = createSelector(getOrderState, (state: OrderState) => state.guestCheckoutOrderID);

export const getCustomerInfo = createSelector(getOrderState, (state: OrderState) => state.customerInfo);

export const getOrderItems = createSelector(getOrderState, (state: OrderState) => state.orderItems);

export const getReOrderItems = createSelector(getOrderState, (state: OrderState) => state.reOrderItems);

export const getOrderID = createSelector(getOrderState, (state: OrderState) => state.orderID);

export const getPaymentSessionIntent = createSelector(getOrderState, (state: OrderState) => state.paymentSessionIntent);

export const getOrderNotes = createSelector(getOrderState, (state: OrderState) => state.notes);
